export const string = attr => attr;

string.stringify = s => s;

export default string;
